import { render, staticRenderFns } from "./Lgx264345530216218624.vue?vue&type=template&id=56441e6a&"
import script from "./Lgx264345530216218624.vue?vue&type=script&lang=js&"
export * from "./Lgx264345530216218624.vue?vue&type=script&lang=js&"
import style0 from "./Lgx264345530216218624.vue?vue&type=style&index=0&id=56441e6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports